import type { PdvFlagIssue } from 'Services/Query/Pdv';

/** What still stands between the rep and Send; empty when the report is complete. */
export const missingStep = (
  mode: PdvFlagIssue,
  attr: string | null,
  note: string
) => {
  if (mode !== 'other' && !attr) return 'Choose an attribute';
  if (mode === 'other' && !note.trim()) return 'Describe the problem';
  return '';
};

/** One line per sent report, on the "Report sent" screen. */
export const sentLine = (
  mode: PdvFlagIssue,
  attr: string | null,
  current: string,
  note: string
) => {
  if (mode === 'other') {
    const trimmed = note.trim();
    return `Something else: "${trimmed.slice(0, 60)}${trimmed.length > 60 ? '…' : ''}"`;
  }
  if (mode === 'wrong') return `${attr}: ${current || '—'}`;
  return `Missing: ${attr}`;
};
